import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,{staticClass:"ma-0 pa-0",attrs:{"fluid":""}},[_c('div',{staticClass:"header pa-3 pb-0"},[_c('div',{staticClass:"px-3 py-0"},[_c('BackButton',{}),_c('div',{staticClass:"page_title bg"},[_c('h2',{staticClass:"title mt-2"},[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"page_subtitle"},[_c('p',{staticClass:"subtitle mt-2"},[_vm._v(_vm._s(_vm.subtitle))])])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }